import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-upload-source-document-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class ControlUploadSourceDocumentApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.controlUploadSourceDocumentApi"),
            description: this.translation.t("specs.controlUploadSourceDocumentApiDescription"),

            httpMethod: "POST",
            path: "/controls/testing/advanced/effectiveness/{effectivenessGuid}/automation/sourcedocuments",

            parameters: [
                {
                    name: "effectivenessGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "idColumn",
                    description: this.translation.t("parameters.controlIdColumnDescription"),
                    in: "query",
                    paramType: "integer",
                    required: false,
                    example: "1 | 2 | 3",
                },
                {
                    name: "nrOfHeadingRowsToSkip",
                    description: this.translation.t("parameters.controlNrOfHeadingRowsToSkipDescription"),
                    in: "query",
                    paramType: "integer",
                    required: false,
                    example: "1 | 2 | 3",
                },
                {
                    name: "sourceDocument",
                    description: this.translation.t("parameters.controlSourceDocumentDescription"),
                    in: "formData",
                    paramType: "file",
                    required: true,
                    example: "binary",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "Request has been successfully processed",
                },
            ],
        };
    }
}
